(() => {
  const initialize = scope => {
    scope.querySelectorAll('[data-cc-services-page]').forEach(root => {
      if (root.dataset.ccsReady) return;
      root.dataset.ccsReady = 'true';
      const stringsNode = root.querySelector('[data-ccs-text]');
      const text = stringsNode ? JSON.parse(stringsNode.textContent) : {};
      const scrollTo = target => {
        const header = document.querySelector('.shopify-section-header');
        target.style.scrollMarginTop = ((header ? header.getBoundingClientRect().height : 0) + 24) + 'px';
        target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
      };
      root.querySelectorAll('a[href="#ccs-choose"]').forEach(link => link.addEventListener('click',event => {
        const target = root.querySelector('#ccs-choose');
        if (!target) return;
        event.preventDefault();
        const heading = target.querySelector('h2');
        heading.tabIndex = -1; heading.focus({preventScroll:true}); scrollTo(target);
      }));
      root.querySelectorAll('[data-card-variant]').forEach(select => {
        const card = select.closest('[data-product-card]');
        const update = () => {
          const option = select.selectedOptions[0];
          card.querySelector('[data-card-price]').textContent = option.dataset.price;
          card.querySelector('[data-card-unavailable]').hidden = option.dataset.available === 'true';
          const photo = card.querySelector('.ccs-product-image img');
          if (photo && option.dataset.image) {
            photo.removeAttribute('srcset');
            photo.src = option.dataset.image;
          }
          const link = card.querySelector('[data-card-link]');
          link.href = link.dataset.productUrl + '?variant=' + option.value;
        };
        select.addEventListener('change',update); update();
      });
      const hireType = root.querySelector('[data-hire-type]');
      if (hireType) {
        const party = root.querySelector('[data-hire-party]');
        const cards = Array.from(root.querySelectorAll('[data-rental-group]'));
        const update = () => {
          party.disabled = hireType.value === 'individual';
          let count = 0;
          cards.forEach(card => {
            const match = card.dataset.rentalGroup === hireType.value && (hireType.value === 'individual' || party.value === '0' || (Number(party.value) <= Number(card.dataset.capacity) && Number(party.value) <= 4));
            card.hidden = !match; if (match) count++;
          });
          root.querySelector('[data-rental-status]').textContent = count + ' ' + text.results;
          root.querySelector('[data-rental-empty]').hidden = count !== 0;
        };
        hireType.addEventListener('change',() => {party.value='0';update();});
        party.addEventListener('change',update);
        root.querySelector('[data-rental-reset]').addEventListener('click',() => {hireType.value='package';party.value='0';update();party.focus();});
        update();
      }
      const switching = (controlAttribute,panelAttribute) => {
        const controls = Array.from(root.querySelectorAll('['+controlAttribute+']'));
        const panels = Array.from(root.querySelectorAll('['+panelAttribute+']'));
        if (!controls.length) return;
        const activate = control => {
          const key = control.getAttribute(controlAttribute);
          controls.forEach(item => item.setAttribute('aria-pressed',String(item===control)));
          panels.forEach(panel => {panel.hidden=panel.getAttribute(panelAttribute)!==key;});
        };
        controls.forEach(control => control.addEventListener('click',()=>activate(control)));
        activate(controls[0]);
      };
      switching('data-service-mode','data-service-panel');
      switching('data-program','data-program-panel');
      switching('data-market-mode','data-market-panel');
      const variantData = root.querySelector('[data-clean-variants]');
      if (variantData) {
        const variants = JSON.parse(variantData.textContent);
        const selects = Array.from(root.querySelectorAll('[data-clean-option]'));
        const initial = variants.find(variant=>variant.available) || variants[0];
        selects.forEach((select,index)=>{select.value=initial.options[index];});
        const update = () => {
          const variant = variants.find(item=>item.options.every((option,index)=>option===selects[index].value));
          const available = !!variant?.available;
          const link = root.querySelector('[data-clean-link]');
          root.querySelector('[data-clean-price]').textContent = variant ? variant.price : '—';
          root.querySelector('[data-clean-status]').textContent = available ? text.cleanReview : text.unavailable;
          link.textContent = available ? text.book + ' ↗' : text.contact + ' ↗';
          link.href = available ? link.dataset.productUrl + '?variant=' + variant.id : '/pages/contact-us';
        };
        selects.forEach(select=>select.addEventListener('change',update));update();
      }
      const marketStock = root.querySelector('[data-market-stock]');
      if (marketStock) {
        const cards = Array.from(root.querySelectorAll('[data-product-card]'));
        const update = () => {
          let count=0;
          cards.forEach(card=>{const match=marketStock.value==='all'||card.dataset.available==='true';card.hidden=!match;if(match)count++;});
          root.querySelector('[data-market-status]').textContent=count+' '+text.results;
          root.querySelector('[data-market-empty]').hidden=count!==0;
        };
        marketStock.addEventListener('change',update);update();
      }
    });
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
